import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";

function FilterRPT({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    ma_cn: "",
    ten_mau_in: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.ma_cn) {
      condition.ma_cn = filter.ma_cn;
    }
    if (filter.ten_mau_in) {
      condition.ten_mau_in = {
        $regex: filter.ten_mau_in.split(" ").join(".*"),
        $options: "i",
      };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Mã CN"
        placeholder="Tìm theo mã CN"
        onSearch={(value) => setFilter({ ...filter, ma_cn: value })}
      />
      <FilterText
        label="Tên mẫu in"
        placeholder="Tìm theo tên mẫu in"
        onSearch={(value) => setFilter({ ...filter, ten_mau_in: value })}
      />
    </WrapperFilter>
  );
}

export default FilterRPT;
